import React, {useEffect} from 'react';
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

// components
import JobHistoryFilters from "./_filters";

// labels
import {
    LB_ACTIONS,
    LB_ACTIVE,
    LB_CODE,
    LB_EMPTY_TABLE,
    LB_HOME,
    LB_PRIORITY,
    LIST
} from "../../../components/i18n/i18n";

// actions
import {
    changeListItem,
    setFilter,
    setForm,
    setItem,
    setTableParams
} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";

// services
import {jobHistoryService} from "../../../jwt/_services/configuration/jobHistoryService";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import JobHistoryForm from "./_form";

const JobHistoryList = props => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};


    // Set initial filter
    useEffect(() => {
        if (filter)
            return

        props.setFilter(path, {
            item: {}
        })
    }, []);


    // Handle filter changer
    useEffect(() => {
        if (!filter)
            return

        genericIndexedActions.search(path, jobHistoryService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(JobHistoryForm, { path, data })
    }

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'job',
            text: 'Nombre',
        }, {
            dataField: 'action',
            headerAlign: 'center',
            align: 'center',
            text: 'Acción',
        }, {
            dataField: 'data',
            text: 'Datos',
        }, {
            dataField: 'registerDate',
            text: 'fecha',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
            formatter: (cell, row) => <GenericTableButton
                toolTip={TT_EDIT}
                icon={'fa-eye'}
                permission={'edit'}
                onClick={()=>editItem(row)}
            />
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <JobHistoryFilters path={path}/>

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={LB_EMPTY_TABLE}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}


const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    changeListItem,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(JobHistoryList)